import React from 'react';
import { buildAssetUrl } from '../services/api';

export const getPreviewImagePath = (item) => {
  if (!item) return '';
  return item.thumbnail_path || item.image_path || item.reference_path || '';
};

const OptimizedImage = ({
  src,
  alt,
  eager = false,
  className,
  ...props
}) => {
  const imageSrc = buildAssetUrl(src);

  return (
    <img
      src={imageSrc}
      alt={alt || ''}
      className={className}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      fetchPriority={eager ? 'high' : 'auto'}
      {...props}
    />
  );
};

export default OptimizedImage;
